export const EVENT_TYPE = {
	PAGE_LOAD: "PAGE_LOAD",
	SHOW_ORDER_CLICK: "SHOW_ORDER_CLICK",

	COOPJS_SCROLL_WIDGET_CLICK: "COOPJS_SCROLL_WIDGET_CLICK",
	COOPJS_REWARDS_CLAIM_CLICK: "COOPJS_REWARDS_CLAIM_CLICK",
	COOPJS_COLLECTIVE_CLICK: "COOPJS_COLLECTIVE_CLICK",
	COOPJS_COLLECTIVE_OPTED_CLICK: "COOPJS_COLLECTIVE_OPTED_CLICK",

	WIDGET_CONTACT_US_CLICK: "WIDGET_CONTACT_US_CLICK",
	WIDGET_TRACK_ORDER_CLICK: "WIDGET_TRACK_ORDER_CLICK",

	WIDGET_SHOP_INSTA_CLICK: "WIDGET_SHOP_INSTA_CLICK",
	WIDGET_SHOP_TWITTER_CLICK: "WIDGET_SHOP_TWITTER_CLICK",
	WIDGET_SHOP_FB_CLICK: "WIDGET_SHOP_FB_CLICK",

	WIDGET_DISPLAY: "WIDGET_DISPLAY",
	WIDGET_BRAND_DISPLAY: "WIDGET_BRAND_DISPLAY",
	WIDGET_LOAD: "WIDGET_LOAD",
	WIDGET_STORY_DISPLAY: "WIDGET_STORY_DISPLAY",

	WIDGET_EMAIL_CLICK: "WIDGET_EMAIL_CLICK",
	WIDGET_SMS_CLICK: "WIDGET_SMS_CLICK",
	WIDGET_EMAIL_SEND: "WIDGET_EMAIL_SEND",
	WIDGET_SMS_SEND: "WIDGET_SMS_SEND",

	WIDGET_SURVEY_DISPLAY: "WIDGET_SURVEY_DISPLAY",
	WIDGET_SURVEY_MODAL_DISPLAY: "WIDGET_SURVEY_MODAL_DISPLAY",
	WIDGET_SURVEY_CLICK: "WIDGET_SURVEY_CLICK",
	WIDGET_SURVEY_MODAL_CLICK: "WIDGET_SURVEY_MODAL_CLICK",
	WIDGET_SURVEY_MODAL_SKIP: "WIDGET_SURVEY_MODAL_SKIP",
	WIDGET_SURVEY_NO_ORDER: "WIDGET_SURVEY_NO_ORDER",

	WIDGET_SURFACE_SURVEY_DISPLAY: "WIDGET_SURFACE_SURVEY_DISPLAY",
	WIDGET_SURFACE_SURVEY_CLICK: "WIDGET_SURFACE_SURVEY_CLICK",
	WIDGET_SURFACE_SURVEY_SKIP: "WIDGET_SURFACE_SURVEY_SKIP",

	WIDGET_SURFACE_REWARD_DISPLAY: "WIDGET_SURFACE_REWARD_DISPLAY",
	WIDGET_SURFACE_REWARD_CLICK: "WIDGET_SURFACE_REWARD_CLICK",
	WIDGET_SURFACE_REWARD_SKIP: "WIDGET_SURFACE_REWARD_SKIP",
	WIDGET_SURFACE_REWARD_EMAIL_SUBMIT: "WIDGET_SURFACE_REWARD_EMAIL_SUBMIT",

	WIDGET_SURFACE_CUSTOM_POST_DISPLAY: "WIDGET_SURFACE_CUSTOM_POST_DISPLAY",

	WIDGET_SURFACE_PRODUCT_SHARE: "WIDGET_SURFACE_PRODUCT_SHARE",

	WIDGET_REWARD_MODAL_DISPLAY: "WIDGET_REWARD_MODAL_DISPLAY",
	WIDGET_REWARD_MODAL_CLICK: "WIDGET_REWARD_MODAL_CLICK",
	WIDGET_REWARD_MODAL_SKIP: "WIDGET_REWARD_MODAL_SKIP",
	WIDGET_REWARD_EMAIL_SUBMIT: "WIDGET_REWARD_EMAIL_SUBMIT",

	WIDGET_CUSTOM_POST_DISPLAY: "WIDGET_CUSTOM_POST_DISPLAY",

	WIDGET_PDP_OPEN: "WIDGET_PDP_OPEN", // done
	WIDGET_PDP_CLOSE: "WIDGET_PDP_CLOSE", // done
	WIDGET_PDP_DISPLAY: "WIDGET_PDP_DISPLAY", // done
	WIDGET_PDP_IMAGE_CLICK: "WIDGET_PDP_IMAGE_CLICK", // done
	WIDGET_PDP_PRODUCT_DETAIL_CLICK: "WIDGET_PDP_PRODUCT_DETAIL_CLICK", // done
	WIDGET_PDP_BRAND_DETAIL_CLICK: "WIDGET_PDP_BRAND_DETAIL_CLICK", // done
	WIDGET_PDP_SIMILAR_PRODUCT_DISPLAY: "WIDGET_PDP_SIMILAR_PRODUCT_DISPLAY", // done
	WIDGET_PDP_SIMILAR_PRODUCT_CLICK: "WIDGET_PDP_SIMILAR_PRODUCT_CLICK", // done
	WIDGET_PDP_SHARE: "WIDGET_PDP_SHARE", // done => all properties similar to PRODUCT_DISPLAY EVENT IN PDP
	WIDGET_PDP_VARIANT_SCREEN_OPEN: "WIDGET_PDP_VARIANT_SCREEN_OPEN", // done => all properties similar to PRODUCT_DISPLAY EVENT IN PDP => DISTINGUISH BETWEEN A SELECT DETAIL CLICK AND ACTUAL BUTTON CLICK
	WIDGET_PDP_VARIANT_SCREEN_CLOSE: "WIDGET_PDP_VARIANT_SCREEN_CLOSE", // done => all properties similar to PRODUCT_DISPLAY EVENT IN PDP
	WIDGET_PDP_CHECKOUT_CLICK: "WIDGET_PDP_CHECKOUT_CLICK", // done => { parameter to distinguish b/w ariant =>>>> variant_screen: bool} | EXACT VARIANT ID OF THE PRODUCT | THE QUANTITY

	WIDGET_BRAND_FOOTER_SCROLL: "WIDGET_BRAND_FOOTER_SCROLL",
	WIDGET_BRAND_FOOTER_OPEN: "WIDGET_BRAND_FOOTER_OPEN",
	WIDGET_BRAND_FOOTER_CLOSE: "WIDGET_BRAND_FOOTER_CLOSE",
	WIDGET_BRAND_FOOTER_DISCOVER_CLICK: "WIDGET_BRAND_FOOTER_DISCOVER_CLICK",
	WIDGET_FOOTER_BRAND_DISPLAY: "WIDGET_FOOTER_BRAND_DISPLAY",

	WIDGET_GROUP_HEADER_CLICK: "WIDGET_GROUP_HEADER_CLICK",
	WIDGET_GROUP_HEADER_ACTIVE: "WIDGET_GROUP_HEADER_ACTIVE",

	CLICK_BRAND: "CLICK_BRAND",
	CLICK: "CLICK",
	UPSELL_CLICK: "UPSELL_CLICK",

	WIDGET_OFFER_CLICK: "WIDGET_OFFER_CLICK", // for the inline brand offer button
	WIDGET_COOP_LOGO_CLICK: "WIDGET_COOP_LOGO_CLICK",
	WIDGET_SEE_MORE_CLICK: "WIDGET_SEE_MORE_CLICK",
	WIDGET_CONSUMER_REDIRECT_CLICK: "WIDGET_CONSUMER_REDIRECT_CLICK",

	WIDGET_LOADING_SCREEN_DISPLAY: "WIDGET_LOADING_SCREEN_DISPLAY",
	WIDGET_SKELETON_SCREEN_DISPLAY: "WIDGET_SKELETON_SCREEN_DISPLAY",
	WIDGET_HEADER_BRAND_LOGO_HOVER: "WIDGET_HEADER_BRAND_LOGO_HOVER",
	WIDGET_HEADER_NAV_CLICK: "WIDGET_HEADER_NAV_CLICK",
	WIDGET_BRAND_LEAD_TILE_DISPLAY: "WIDGET_BRAND_LEAD_TILE_DISPLAY",
	WIDGET_PRODUCT_STORY_IMG_CLICK: "WIDGET_PRODUCT_STORY_IMG_CLICK",

	WIDGET_BRAND_SAVER_DISMISS_CLICK: "WIDGET_BRAND_SAVER_DISMISS_CLICK",

	WIDGET_BRAND_SAVER_DISCOUNT_DISPLAY: "WIDGET_BRAND_SAVER_DISCOUNT_DISPLAY",
	WIDGET_BRAND_SAVER_DISCOUNT_CLICK: "WIDGET_BRAND_SAVER_DISCOUNT_CLICK",

	WIDGET_BRAND_SAVER_FAVE_DISPLAY: "WIDGET_BRAND_SAVER_FAVE_DISPLAY",
	WIDGET_BRAND_SAVER_FAVE_CLICK: "WIDGET_BRAND_SAVER_FAVE_CLICK",
	WIDGET_BRAND_SAVER_FAVE_DRAWER_DISPLAY:
		"WIDGET_BRAND_SAVER_FAVE_DRAWER_DISPLAY",
	WIDGET_BRAND_SAVER_FAVE_DRAWER_DISMISS:
		"WIDGET_BRAND_SAVER_FAVE_DRAWER_DISMISS", // target: CLOSE_BUTTON, GRABBER

	WIDGET_BRAND_SAVER_SHOP_NOW_DISPLAY: "WIDGET_BRAND_SAVER_SHOP_NOW_DISPLAY",

	WIDGET_BRAND_SAVER_INPUT_DISPLAY: "WIDGET_BRAND_SAVER_INPUT_DISPLAY",
	WIDGET_BRAND_SAVER_INPUT_SAVE: "WIDGET_BRAND_SAVER_INPUT_SAVE",
	WIDGET_BRAND_SAVER_INPUT_CANCEL: "WIDGET_BRAND_SAVER_INPUT_CANCEL",

	WIDGET_PPE_TOGGLE: "WIDGET_PPE_TOGGLE",

	WIDGET_ELEMENT_CLICK: "WIDGET_ELEMENT_CLICK",

	// EXPERIMENTS
	WIDGET_EMAIL_OPT_IN_CLICK: "WIDGET_EMAIL_OPT_IN_CLICK",
	WIDGET_BRAND_INLINE_OFFER_DISPLAY: "WIDGET_BRAND_INLINE_OFFER_DISPLAY",
	WIDGET_BRAND_INLINE_OFFER_CLICK: "WIDGET_BRAND_INLINE_OFFER_CLICK",

	// DEBUG
	WIDGET_DEBUG: "WIDGET_DEBUG",
};

export const BRAND_CLICK_TARGET = {
	LOGO: "LOGO",
	HEADER: "HEADER",
	SHOP_BUTTON: "SHOP_BUTTON",

	LEAD_TILE: "LEAD_TILE",
	STORY_TILE_LOGO: "STORY_TILE_LOGO",

	DISCO_CASH_SHOP_BUTTON: "DISCO_CASH_SHOP_BUTTON",

	DISCO_FEED_1: "DISCO_FEED_1",

	INLINE_COVER_TILE: "INLINE_COVER_TILE",
	INLINE_ACTION_BUTTON: "INLINE_ACTION_BUTTON",
	BOTTOM_SLOT: "BOTTOM_SLOT",
};

export const PRODUCT_CLICK_TARGET = {
	DISCO_FEED_1: "DISCO_FEED_1",

	TILE: "TILE",
	INLINE_PRODUCT_TILE: "INLINE_PRODUCT_TILE",

	PDP: "PDP",
	STORY_TILE: "STORY_TILE",

	BOTTOM_SLOT: "BOTTOM_SLOT",
};

export const BRAND_SAVER_FAVE_CLICK_TARGET = {
	FAVE_BUTTON: "FAVE_BUTTON",
	BRAND_BADGE: "BRAND_BADGE",
};

export const WIDGET_CONSUMER_REDIRECT_TARGET = {
	DISCO_LOGO: "DISCO_LOGO",
	INLINE_OFFER_BANNER_DISCO_LOGO: "INLINE_OFFER_BANNER_DISCO_LOGO",
};

export const WIDGET_EMAIL_OPT_IN_TARGET = {
	HEADER: "HEADER",
};
export const WIDGET_DEBUG_TARGET = {
	WIDGET_LOAD: "WIDGET_LOAD",
};

export const WIDGET_ELEMENT_CLICK_TARGET = {
	INLINE_FOOTER_DISCO: "INLINE_FOOTER_DISCO",
	INLINE_FOOTER_PRIVACY: "INLINE_FOOTER_PRIVACY",
	INLINE_NAV_FORWARD: "INLINE_NAV_FORWARD",
	INLINE_NAV_BACKWARD: "INLINE_NAV_BACKWARD",

	EXPLICIT_NAV_FORWARD: "EXPLICIT_NAV_FORWARD",
	EXPLICIT_NAV_BACKWARD: "EXPLICIT_NAV_BACKWARD",

	CLOSE_BUTTON: "CLOSE_BUTTON",
	CONSUMER_REDIRECT: "CONSUMER_REDIRECT",
};

export const ELEMENT_ENGAGEMENT_TARGET = {
	BRAND_ROW: "BRAND_ROW",
};
export const ELEMENT_ENGAGEMENT_TYPE = {
	HORIZONTAL_SCROLL: "HORIZONTAL_SCROLL",
};
